export const HumanFriendlyDate = (date: Date) =>
  date.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });

export const HumanFriendlyStringDate = (date: string) => HumanFriendlyDate(new Date(date));
